import React from "react"
import Layout from "../components/layout"
import Post from "../components/post"

export default function Home() {
  return (
  <Layout>
    <div class="cards">
      <Post 
      link="venice"
      photo="/images/venice/cover-venice.jpeg"
      photoDescription="Tesla Model 3 before the Lido theater"
      title="Cinematic Sights And Vibes On Lido, Venice's Alternative Destination" 
      description="Stunning ferry rides, a newly renovated historical hotel and almost no other tourists in Venice."
      date="January, 2020"/>
    </div>
  </Layout>
  )
}
